/* eslint-disable */
import React, { useState, memo, useLayoutEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import srv from '../../services';
import moment from 'moment';
import { Button } from 'antd';

const useStyles = makeStyles({
 dialog: {
  height: '100%',
  padding: '20px',
 },

 dialogContainer: {
  '& .MuiDialog-container': {
   justifyContent: 'center',
   justifyItems: 'center',
   display: 'flex',
   width: '100%',
   backgroundColor: 'none',
   overflow: 'hidden',
   //height: '1000px',
   flexDirection: 'column',
  },
  '& .MuiTypography-root': {
   display: 'flex',
   alignItems: 'center',
  },
  '& .MuiDialogContent-root': {
   overflow: 'hidden',
   padding: '0 !important',
   margin: '0 !important',
  },
  '& .MuiDialog-paper': {
   height: '200px',
   border: '1px #FFB614 solid !important',
  },
  '& .MuiModal-backdrop': {
   backgroundColor: 'transparent !important',
  },
 },
 dialogTitle: {
  height: '20px',
  color: 'black !important',
 },
 container: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  padding: 0,
  flexDirection: 'row',
 },
 headerTitle: {
  fontWeight: 'bold',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'calibri',
  padding: '5px 40px',
  borderRadius: '10px',
 },
 banner: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
 },
});

function PaperComponent(props: PaperProps) {
 return (
  <Draggable
   handle="#draggable-dialog-title"
   cancel={'[class*="MuiDialogContent-root"]'}
  >
   <Paper {...props} />
  </Draggable>
 );
}

interface notificationRequest {
 contractId: string;
 id: string;
 deliveryDate: string;
}

/**
 * Окно банера.
 * @param props
 * @returns
 */
const DialogRestrictionsNotifications = (props: any) => {
 const classes = useStyles();
 const [open, setOpen] = useState(props.showBanner);
 useLayoutEffect(() => {
  setOpen(true);
 }, []);

 const closeDialogHandler = () => {
  const payload: notificationRequest = {
   contractId: props?.item?.contractId,
   id: props?.item?.notificationId,
   deliveryDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
  };

  srv.confirmDeliveryRestrictionNotifications(payload).then((response) => {
   if (response && response.data) {
    const value = response;
   }
  });
  setOpen(false);
 };

 return (
  <div>
   <Dialog
    className={classes.dialogContainer}
    open={open}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
    PaperProps={{
     sx: {
      width: '700px',
      height: '500px',
      maxWidth: '700px',
      overflow: 'hidden',
      marginTop: '20px',
     },
    }}
   >
    <DialogTitle
     className={classes.dialogTitle}
     style={{
      cursor: 'move',
     }}
     id="draggable-dialog-title"
    >
     <div className={classes.container}>
      <div
       className={classes.headerTitle}
       style={{
        color: 'black',
        marginTop: '1px',
        marginLeft: '-40px',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
       }}
      >
       <div
        style={{ marginTop: '6px', color: 'black' }}
       >{`Уведомление №${props?.item?.id}`}</div>
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         marginLeft: '30px',
         marginTop: '7px',
        }}
       ></div>
      </div>

      <div
       style={{
        cursor: 'pointer',
        marginTop: '5px',
        textAlign: 'center',
        width: '100%',
       }}
      >
       <Button
        style={{
         width: '100px',
         height: '30px',
         borderColor: '#FFB614',
         marginTop: '300px',
         marginRight: '250px',
        }}
        size="small"
        type="link"
        onClick={closeDialogHandler}
       >
        OK
       </Button>

       {/* <CloseIcon
        style={{
         marginTop: '8px',
         marginRight: '-15px',
         fontWeight: 800,
         color: 'black',
        }}
        onClick={closeDialogHandler}
       /> */}
      </div>
     </div>
    </DialogTitle>
    <DialogContent className={classes.dialog}>
     <div
      style={{
       padding: '10px',
       fontFamily: 'calibri',
       overflow: 'auto',
       width: '100%',
       height: '120px',
      }}
     >
      {props?.item?.noticeOfRestriction}
     </div>
    </DialogContent>
   </Dialog>
  </div>
 );
};

export default memo(DialogRestrictionsNotifications);
